<template>
  <div class="container content mt-12 md:flex items-baseline">
    <div class="md:w-2/3 md:pr-12">
      <h2>
        Technical Issues/Bugs
      </h2>
      <p>
        If you have any technical questions regarding the portal, please email:
      </p>

      <p>
        <a :href="`mailto:${$config.emails.technical}`">
          {{ $config.emails.technical }}
        </a>
      </p>

      <h2>
        Competition or Funding
      </h2>
      <p>
        For any competition related questions, please email:
      </p>

      <p>
        <a :href="`mailto:${$config.emails.support}`">
          {{ $config.emails.support }}
        </a>
      </p>
    </div>
    <!-- <div class="md:w-1/3 mt-12 md:mt-0">
    </div> -->
  </div>
</template>

<script>
export default {
  name: "PageHelpIndex"
};
</script>
